import { isNaN } from "lodash";

export default function(value, options) {
  if (!isNaN(value) && value !== null) {
    return parseInt(value, 10);
  }
  return 0;
}
